import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { darken } from '@mui/material/styles';

import THEME from '@/app/modules/ECommerce/pages/miniPOS/utils/theme';
import BranchAppBar from '@/app/modules/ECommerce/pages/miniPOS/components/BranchAppBar';
import FuncrowdIC from '@/app/modules/ECommerce/pages/miniPOS/icons/funcrowdIC.png';
import { LanguageSelectorDropdown } from '@/_metronic/layout/components/extras/dropdowns/LanguageSelectorDropdown';
import UserAvatarMenu from './UserAvatarMenu';

const MiniPOSAppBar = ({ height = 75 }) => {
  const history = useHistory();
  const { shop } = useSelector(state => state.auth);

  return (
    <AppBar position="fixed" sx={{ zIndex: theme => theme.zIndex.drawer + 1, bgcolor: '#ffff', height: height }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex' }}>
          <Box
            onClick={() => history.push(`/shop/${shop?.seqId}/mini-pos/home`)}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Box
              component="img"
              src={shop?.logo?.data}
              alt="shop logo"
              sx={{
                width: 32,
                height: 32,
                mr: 1
              }}
            />
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                color: THEME.primary,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                fontWeight: 1000,
                '&:hover': {
                  color: THEME.primary,
                  fontSize: '1.35rem'
                },
                '&:active': {
                  color: darken(THEME.primary)
                }
              }}
            >
              {shop?.name || 'Funcrowd POS'}
            </Typography>
          </Box>

          <BranchAppBar />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <UserAvatarMenu />
          <LanguageSelectorDropdown />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MiniPOSAppBar;
